// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Navigation Sidebar Styles */

/* CSS Custom Properties */
:root {
  --sidebar-width: 16rem;
}

/* Custom scrollbar for navigation */
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: hsl(var(--color-muted)) transparent;
}

.scrollbar-thin::-webkit-scrollbar {
  width: 4px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background-color: hsl(var(--color-muted));
  border-radius: 2px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background-color: hsl(var(--color-muted-foreground) / 0.5);
}

/* Smooth height transitions for viewport changes - mobile only */
@media (max-width: 1024px) {
  @supports (height: 100dvh) {
    .navigation-sidebar {
      height: 100dvh;
    }
  }

  @supports not (height: 100dvh) {
    .navigation-sidebar {
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
    }
  }
}

/* Desktop: Fixed positioning with full height */
@media (min-width: 1024px) {
  .navigation-sidebar {
    height: 100vh;
    height: 100dvh; /* Use dynamic viewport height */
    position: fixed;
    top: 0;
    left: 0;
  }
}

/* Main content adjustment for fixed sidebar */
@media (min-width: 1024px) {
  .main-content {
    margin-left: var(--sidebar-width, 16rem);
    transition: margin-left 300ms cubic-bezier(0.4, 0, 0.2, 1);
  }
}

/* Enhanced focus styles for accessibility */
.navigation-item:focus-visible {
  outline: 2px solid hsl(var(--color-primary));
  outline-offset: 2px;
  border-radius: 6px;
}

/* Improved mobile touch targets */
@media (max-width: 1024px) {
  .navigation-item {
    min-height: 48px;
    padding: 12px 16px;
  }
}

/* Animation for active state indicator */
.active-indicator {
  animation: slideIn 200ms ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(-50%);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(-50%);
  }
}

/* Backdrop blur fallback for older browsers */
@supports not ((-webkit-backdrop-filter: blur(8px)) or (backdrop-filter: blur(8px))) {
  .navigation-sidebar {
    background-color: hsl(var(--color-card));
  }
}

/* Safe area insets for mobile devices */
.navigation-sidebar {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
}

/* Enhanced hover states */
.navigation-item:hover {
  transform: translateX(1px);
  transition: transform 200ms ease-out;
}

.navigation-item.collapsed:hover {
  transform: scale(1.05);
}

/* Loading skeleton for navigation items */
.navigation-skeleton {
  background: linear-gradient(90deg, 
    hsl(var(--color-muted)) 25%, 
    hsl(var(--color-muted) / 0.5) 50%, 
    hsl(var(--color-muted)) 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Improved mobile overlay */
.mobile-overlay {
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 300ms ease-in-out;
}

/* Collapsible animation improvements */
.sidebar-collapsed {
  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-expanded {
  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .navigation-sidebar {
    border-width: 2px;
  }
  
  .navigation-item {
    border: 1px solid transparent;
  }
  
  .navigation-item:focus {
    border-color: hsl(var(--color-primary));
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .navigation-item,
  .sidebar-collapsed,
  .sidebar-expanded,
  .active-indicator {
    transition: none;
    animation: none;
  }
}

/* Dark mode specific adjustments */
.dark .navigation-sidebar {
  border-color: hsl(var(--color-border) / 0.3);
}

.dark .scrollbar-thin::-webkit-scrollbar-thumb {
  background-color: hsl(var(--color-muted) / 0.7);
}

/* Print styles */
@media print {
  .navigation-sidebar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navigation-enhanced.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,0BAA0B;AAC1B;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,iEAAiE;AACjE;EACE;IACE;MACE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,aAAa;MACb,kCAAkC;IACpC;EACF;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,cAAc,EAAE,gCAAgC;IAChD,eAAe;IACf,MAAM;IACN,OAAO;EACT;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,wCAAwC;IACxC,0DAA0D;EAC5D;AACF;;AAEA,4CAA4C;AAC5C;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;AACzC;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE;;;gCAG8B;EAC9B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,4BAA4B;AAC5B;EACE,kCAA0B;UAA1B,0BAA0B;EAC1B,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA,uCAAuC;AACvC;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;IAIE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Enhanced Navigation Sidebar Styles */\n\n/* CSS Custom Properties */\n:root {\n  --sidebar-width: 16rem;\n}\n\n/* Custom scrollbar for navigation */\n.scrollbar-thin {\n  scrollbar-width: thin;\n  scrollbar-color: hsl(var(--color-muted)) transparent;\n}\n\n.scrollbar-thin::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollbar-thin::-webkit-scrollbar-thumb {\n  background-color: hsl(var(--color-muted));\n  border-radius: 2px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-thumb:hover {\n  background-color: hsl(var(--color-muted-foreground) / 0.5);\n}\n\n/* Smooth height transitions for viewport changes - mobile only */\n@media (max-width: 1024px) {\n  @supports (height: 100dvh) {\n    .navigation-sidebar {\n      height: 100dvh;\n    }\n  }\n\n  @supports not (height: 100dvh) {\n    .navigation-sidebar {\n      height: 100vh;\n      height: calc(var(--vh, 1vh) * 100);\n    }\n  }\n}\n\n/* Desktop: Fixed positioning with full height */\n@media (min-width: 1024px) {\n  .navigation-sidebar {\n    height: 100vh;\n    height: 100dvh; /* Use dynamic viewport height */\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n}\n\n/* Main content adjustment for fixed sidebar */\n@media (min-width: 1024px) {\n  .main-content {\n    margin-left: var(--sidebar-width, 16rem);\n    transition: margin-left 300ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n}\n\n/* Enhanced focus styles for accessibility */\n.navigation-item:focus-visible {\n  outline: 2px solid hsl(var(--color-primary));\n  outline-offset: 2px;\n  border-radius: 6px;\n}\n\n/* Improved mobile touch targets */\n@media (max-width: 1024px) {\n  .navigation-item {\n    min-height: 48px;\n    padding: 12px 16px;\n  }\n}\n\n/* Animation for active state indicator */\n.active-indicator {\n  animation: slideIn 200ms ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-4px) translateY(-50%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0) translateY(-50%);\n  }\n}\n\n/* Backdrop blur fallback for older browsers */\n@supports not (backdrop-filter: blur(8px)) {\n  .navigation-sidebar {\n    background-color: hsl(var(--color-card));\n  }\n}\n\n/* Safe area insets for mobile devices */\n.navigation-sidebar {\n  padding-top: env(safe-area-inset-top);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n/* Enhanced hover states */\n.navigation-item:hover {\n  transform: translateX(1px);\n  transition: transform 200ms ease-out;\n}\n\n.navigation-item.collapsed:hover {\n  transform: scale(1.05);\n}\n\n/* Loading skeleton for navigation items */\n.navigation-skeleton {\n  background: linear-gradient(90deg, \n    hsl(var(--color-muted)) 25%, \n    hsl(var(--color-muted) / 0.5) 50%, \n    hsl(var(--color-muted)) 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Improved mobile overlay */\n.mobile-overlay {\n  backdrop-filter: blur(4px);\n  background-color: rgba(0, 0, 0, 0.5);\n  transition: opacity 300ms ease-in-out;\n}\n\n/* Collapsible animation improvements */\n.sidebar-collapsed {\n  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar-expanded {\n  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .navigation-sidebar {\n    border-width: 2px;\n  }\n  \n  .navigation-item {\n    border: 1px solid transparent;\n  }\n  \n  .navigation-item:focus {\n    border-color: hsl(var(--color-primary));\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .navigation-item,\n  .sidebar-collapsed,\n  .sidebar-expanded,\n  .active-indicator {\n    transition: none;\n    animation: none;\n  }\n}\n\n/* Dark mode specific adjustments */\n.dark .navigation-sidebar {\n  border-color: hsl(var(--color-border) / 0.3);\n}\n\n.dark .scrollbar-thin::-webkit-scrollbar-thumb {\n  background-color: hsl(var(--color-muted) / 0.7);\n}\n\n/* Print styles */\n@media print {\n  .navigation-sidebar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
